enum PaymentState {
  Paid,
  Returned,
}

export default PaymentState;
